import React from 'react';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Layout from './Layout/Layout';
import ProtectedRoute from './Layout/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import TranslationPage from './pages/TranslationPage';
import SpeechToTextPage from './pages/SpeechToTextPage';
import OcrPage from './pages/OcrPage';
import ParaphrasingPage from './pages/ParaphrasingPage';
import UpdateAalimPage from './pages/UpdateAalimPage';
import ViewChatsPage from './pages/ViewChatsPage';
import ViewQalamChatsPage from './pages/ViewQalamChatsPage';
import ViewUsersPage from './pages/ViewUsersPage';
import ViewMaktabPage from './pages/ViewMaktabPage';
import RequestedBooksPage from './pages/RequestedBooksPage';
import FeedbacksPage from './pages/FeedbacksPage';
import SubscriptionPage from './pages/SubscriptionPage';
import SettingsPage from './pages/SettingsPage';
import './index.css';
import ResearchRequestsPage from "./pages/ResearchRequestsPage";
import DonationsPage from "./pages/DonationsPage";
import AdminUsagePage from "./pages/AdminUsagePage";
import BulkEmailPage from "./pages/BulkEmailPage";
import AnnouncementsPage from "./pages/AnnouncementsPage";
import DatabaseBackupsPage from "./pages/DatabaseBackupsPage";

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<LoginPage/>}/>

                {/* Protected Routes */}
                <Route path="/dashboard" element={
                    <ProtectedRoute>
                        <Layout>
                            <DashboardPage/>
                        </Layout>
                    </ProtectedRoute>
                }/>

                <Route path="/translation" element={
                    <ProtectedRoute>
                        <Layout>
                            <TranslationPage/>
                        </Layout>
                    </ProtectedRoute>
                }/>

                <Route path="/speech-to-text" element={
                    <ProtectedRoute>
                        <Layout>
                            <SpeechToTextPage/>
                        </Layout>
                    </ProtectedRoute>
                }/>

                <Route path="/ocr" element={
                    <ProtectedRoute>
                        <Layout>
                            <OcrPage/>
                        </Layout>
                    </ProtectedRoute>
                }/>

                <Route path="/paraphrasing" element={
                    <ProtectedRoute>
                        <Layout>
                            <ParaphrasingPage/>
                        </Layout>
                    </ProtectedRoute>
                }/>

                <Route path="/update-aalim" element={
                    <ProtectedRoute>
                        <Layout>
                            <UpdateAalimPage/>
                        </Layout>
                    </ProtectedRoute>
                }/>

                <Route path="/view-chats" element={
                    <ProtectedRoute>
                        <Layout>
                            <ViewChatsPage/>
                        </Layout>
                    </ProtectedRoute>
                }/>

                <Route path="/view-qalam-chats" element={
                    <ProtectedRoute>
                        <Layout>
                            <ViewQalamChatsPage/>
                        </Layout>
                    </ProtectedRoute>
                }/>

                <Route path="/view-users" element={
                    <ProtectedRoute>
                        <Layout>
                            <ViewUsersPage/>
                        </Layout>
                    </ProtectedRoute>
                }/>

                <Route path="/bulk-emails" element={
                    <ProtectedRoute>
                        <Layout>
                            <BulkEmailPage/>
                        </Layout>
                    </ProtectedRoute>
                }/>

                <Route path="/view-maktab" element={
                    <ProtectedRoute>
                        <Layout>
                            <ViewMaktabPage/>
                        </Layout>
                    </ProtectedRoute>
                }/>

                <Route path="/requested-books" element={
                    <ProtectedRoute>
                        <Layout>
                            <RequestedBooksPage/>
                        </Layout>
                    </ProtectedRoute>
                }/>

                <Route path="/feedbacks" element={
                    <ProtectedRoute>
                        <Layout>
                            <FeedbacksPage/>
                        </Layout>
                    </ProtectedRoute>
                }/>

                <Route path="/subscription" element={
                    <ProtectedRoute>
                        <Layout>
                            <SubscriptionPage/>
                        </Layout>
                    </ProtectedRoute>
                }/>

                <Route path="/research-request" element={
                    <ProtectedRoute>
                        <Layout>
                            <ResearchRequestsPage/>
                        </Layout>
                    </ProtectedRoute>
                }/>

                <Route path="/donations" element={
                    <ProtectedRoute>
                        <Layout>
                            <DonationsPage/>
                        </Layout>
                    </ProtectedRoute>
                }/>

                <Route path="/usage-control" element={
                    <ProtectedRoute>
                        <Layout>
                            <AdminUsagePage/>
                        </Layout>
                    </ProtectedRoute>
                }/>

                <Route path="/announcements" element={
                    <ProtectedRoute>
                        <Layout>
                            <AnnouncementsPage/>
                        </Layout>
                    </ProtectedRoute>
                }/>

                <Route path="/database-backups" element={
                    <ProtectedRoute>
                        <Layout>
                            <DatabaseBackupsPage/>
                        </Layout>
                    </ProtectedRoute>
                }/>

                <Route path="/settings" element={
                    <ProtectedRoute>
                        <Layout>
                            <SettingsPage/>
                        </Layout>
                    </ProtectedRoute>
                }/>

                {/* Redirect any unknown paths to dashboard */}
                {/*<Route path="*" element={<Navigate to="/dashboard" replace/>}/>*/}
            </Routes>
        </Router>
    );
};

export default App;